export default "skymp5-front/82b0a0d2772f20c54adc3e8064ec761e.png";